import React, { useContext } from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Button, useMediaQuery, TextField, useTheme } from '@mui/material';

import { Link as RouterLink } from 'react-router-dom';
import { AppContext } from '@/AppContext';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';

const PREFIX = 'ReceptionToolbar';

const classes = {
  root: `${PREFIX}-root`,
  row: `${PREFIX}-row`,
  spacer: `${PREFIX}-spacer`,
  menu: `${PREFIX}-menu`,
  searchField: `${PREFIX}-searchField`,
  groupField: `${PREFIX}-groupField`,
  iconButton: `${PREFIX}-iconButton`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },

  [`& .${classes.row}`]: {
    display: 'flex',
  },

  [`& .${classes.spacer}`]: {
    flexGrow: 1,
  },

  [`& .${classes.menu}`]: {
    marginLeft: theme.spacing(1),
  },

  [`& .${classes.searchField}`]: {
    width: '400px',
    padding: '2px 4px',
  },

  [`& .${classes.groupField}`]: {
    width: '300px',
    padding: '2px 4px',
  },

  [`& .${classes.iconButton}`]: {
    marginTop: '14px',
    width: '36px',
    height: '36px',
  },
}));

const ReceptionToolbar = props => {
  const {
    className,
    meetupId,
    refresh,
    selected,
    searchFieldRef,
    search: outerSearch,
    setSearch: setOuterSearch,
    group: outerGroup,
    setGroup: setOuterGroup,
    ...rest
  } = props;

  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const appContext = useContext(AppContext);

  // const [search, setSearch] = React.useState(outerSearch);
  // const handleSearchDebounced = React.useRef(_.debounce(function (query) {
  //   setOuterSearch(query);
  // }, 300)).current;
  // const handleSearchChange = (query) => {
  //   setSearch(query);
  //   handleSearchDebounced(query);
  // };
  const handleSearchChange = query => {
    setOuterSearch(query);
  };

  const handleBlur = () => {
    // if (window.location.pathname === '/reception') {
    //   document.getElementById('visitors-search-field').focus();
    // }
  };

  return (
    <Root {...rest} className={clsx(classes.root, className)}>
      <div className={classes.row}>
        <IconButton type='submit' size='large'>
          <SearchIcon />
        </IconButton>

        <TextField
          id={'visitors-search-field'}
          autoFocus={true}
          variant='standard'
          // vggonBlur={handleBlur}
          fullWidth
          margin='dense'
          autoComplete='off'
          onChange={e => handleSearchChange(e.target.value)}
          value={outerSearch}
          className={classes.searchField}
          ref={searchFieldRef}
        />

        {isLargeScreen && (
          <>
            <span className={classes.spacer} />
            <RouterLink to={'/reception/visitor/add'}>
              <Button
                color='primary'
                variant='contained'
                style={{ marginTop: '6px' }}
                onClick={() => setOuterSearch('')}
              >
                Добавить посетителя
              </Button>
            </RouterLink>
          </>
        )}
      </div>
    </Root>
  );
};

ReceptionToolbar.propTypes = {
  className: PropTypes.string,
  meetupId: PropTypes.number,
};

export default ReceptionToolbar;
